export const es_us = {
    message: {
        common: {
            collaborators: 'Colaboradores',
            my_profile: 'Mi perfil',
            user: 'Usuario',
            password: 'Contraseña',
            confirm: 'Confirmar',
            back: 'Volver',
            filters: 'Filtros',
            filters_text: 'Filtros referentes a',
            adm: 'Administrador',
            master: 'Administrador Master',
            bdm: 'BDM',
            eng: 'Ingeniero',
            managers: 'Gerente',
            inside: "Inside",
            seller: "Vendedor",
            adm_brand: 'Administradores de marca',
            intermediary: 'Intermediario',
            sellers: "Vendedores",
            clear: 'Limpiar',
            apply: 'Aplicar',
            brands: 'Marcas',
            resales: 'Socios de Negocio',
            goals: 'Metas',
            yes: 'Sí',
            atention: 'Atención',
            session_expired_message: 'Su sesión ha expirado, por favor inicie sesión nuevamente.',
            exit_message: '¿Estás seguro de que quieres irte?',
            version: 'Versión',
            profile: 'Cambiar foto de perfil',
            rights_reserved: 'Aurora, todos los derechos reservados.',
            from: 'De:',
            to: 'Hasta:',
            from_elipssis: 'De...',
            to_elipssis: 'Hasta...',
            future_commission: 'Comisión futura',
            goal_name: 'Nombre de la meta',
            goal_name_elipssis: 'Nombre de la meta...',
            role: 'Función',
            role_elipssis: 'Función...',
            orientation: 'Orientación',
            margin: 'Margen',
            range: 'Rango',
            period: 'Período',
            commission: 'Comisión',
            name: 'Nombre',
            name_elipssis: 'Nombre...',
            performer: 'Desempeño',
            performer_elipssis: 'Desempeño...',
            title: 'Título de la meta',
            goal_orientation: 'Orientación de la meta',
            brand: 'Marca',
            warehouse: 'Depósito',
            cost_center: 'Centro de Costos',
            triggers: 'Gatillos',
            seasonality: 'Estacionalidad',
            Seasonalities: 'Estacionalidades',
            required: 'Obligatorio',
            required_field: 'Campo obligatorio',
            cross: 'Cross',
            transfer: 'Transferencia',
            sale_goal: 'Venta',
            no_information: 'Sin información para mostrar',
            success: '¡Éxito!',
            status: 'Estado',
            export: 'Exportar',
            invoice: 'Factura',
            billing_date: 'Fecha de Facturación',
            total_sales: 'Total de Ventas',
            type_note: 'Tipo',
            line: 'Línea',
            quantity: 'Cantidad',
            commissioning: 'Comisionamiento',
            part_number: 'Part Number',
            installment: 'Cuota',
            installments: 'cuotas',
            duedate: 'Fecha de Vencimiento',
            display: 'Mostrar',
            hide: 'esconderse',
            select: 'Seleccionar',
            sap_code: 'Código en SAP',
            options: 'Opciones',
            search: 'Buscar en la tabla...',
            edit: 'Editar',
            deactivate: 'Desactivar',
            type_confirm: 'Escriba “SÍ” para confirmar',
            continue: 'Continuar',
            no: 'No',
            description: 'Descripción',
            goal_not_found: 'Objetivo no encontrado',
            brand_not_found: 'Marca no encontrada',
            partner_not_found: 'Socio comercial no encontrado',
            warehouse_not_found: 'Depósito no encontrado',
            goal_create_fail: 'Error al crear el objetivo',
            goal_create_success: 'Meta creada exitosamente',
            goal_update_success: 'Objetivo actualizado exitosamente',
            goal_update_fail: 'Error al actualizar el objetivo',
            not_allowed: 'No permitido',
            not_defined: 'No definido',
            portuguese: 'Portugués',
            english: 'Inglés',
            spanish: 'Español',
            sellerName: 'nombre del vendedor',
            register: 'Registro ',
            update: 'Actualizar ',
            data_updated: 'Tus datos han sido actualizados exitosamente',
            unexpected_error: 'Se ha producido un error inesperado en el sistema, comuníquese con el soporte',
            select_collaborator: 'Selecciona el colaborador',
            word_validation: '¡Debes ingresar la palabra para continuar!',
            word_validation_error: '¡La palabra ingresada es diferente de la palabra solicitada!',
            created_text: 'creada con éxito!',
            updated_text: '¡Se ha actualizado exitosamente!',
            deactivated_text: 'desactivada con éxito!',
            select_hiring: '¡Selecciona el modelo de contratación de usuarios!',
            wrong_credentials: 'Información de nombre de usuario o contraseña incorrecta',
            january: 'Enero',
            february: 'Febrero',
            march: 'Marzo',
            april: 'Abril',
            may: 'Puede',
            june: 'Junio',
            july: 'Julio',
            august: 'Agosto',
            september: 'Septiembre',
            october: 'Octubre',
            november: 'Noviembre',
            december: 'Diciembre',
            locale: 'es',
            to_locale: 'de',
            to_date: 'de',
            date_connection: 'al',
            current_month: 'Mes actual',
            last_month: 'Mes pasado',
            home_description_image: '/description_esp.png',
            web_title: `Comisión de ventas`,
            information: 'La información de este portal se actualiza diariamente durante la noche, además las facturas se agregan al portal dos días después de ser facturadas.',
            invoiced_status: 'facturado',
            employee_role: 'Función del colaborador'
        },
        login: {
            welcome: '¡Bienvenido!',
            form_user: 'Rellena correctamente los siguientes campos para acceder a la plataforma',
            user_computer: 'Usuario de la computadora',
            enter: 'Entrar',
            policy: 'Política de privacidad',
            policy_document_link: '/documents/Política_de_Privacidade.pdf',
            new_way: 'Una nueva forma de ver tu información de ventas',
            query: 'Consulta datos sobre tus objetivos, ventas y comisiones de forma rápida y sencilla',
            cookies: 'Para ofrecer la mejor experiencia posible en nuestro sitio web, utilizamos cookies. Al continuar navegando, aceptas el uso de estas cookies. Son esenciales para garantizar funciones como el inicio de sesión seguro. Descubra más en nuestra Política de Privacidad',
            agree: 'Estoy de acuerdo',
        },
        home: {
            greeting: 'Bienvenido al Portal de Comisiones de Ventas',
            values: ' valores',
            search_for_collaborator: 'Buscar colaborador',
            filter_functions: 'Filtro de funciones',
            select_function: 'Seleccione la función deseada',
            commission: 'Comisión a recibir',
            progress_goals: 'Progreso de las metas en el mes actual',
            more_details: 'Ver más detalles',
            showing: 'Mostrando',
            results: 'de {number} resultados',
        },
        goals: {
            filter_goals: 'Filtrar metas por',
            export: 'Exportar metas',
            register: 'Registrar nueva meta',
            date_filter: 'Filtro de fechas',
            select: 'Seleccione el mes/año o período deseado',
            closed: 'Metas cerradas',
            goal_found: 'Ninguna meta encontrada',
        },
        goals_create: {
            employee_information: 'Información del empleado',
            information_goal: 'La siguiente información es válida para el grupo de metas',
            employee: 'Empleado',
            goal_registration: 'Registro de metas',
            fill_field: 'Complete este campo para colocar el título de la meta...',
            resale: 'Socio de Negocio',
            choose_brand: 'Elija la marca',
            choose_cost_center: 'Elige los centros de costos',
            choose_resale: 'Elige el socio de negocio',
            choose_deposits: 'Elija los depósitos',
            period: 'Definición del período',
            from_goals: 'Desde',
            to_goals: 'Hasta',
            optional: 'Configuraciones opcionales',
            add_goal: 'Agregar meta',
            action: 'Acción',
            complete_registration: 'Completar registro',
            goals_created: '¡Las metas se han creado con éxito!',
            ok: 'OK',
            goal_updated: 'Objetivo cambiado con éxito',
        },
        goals_details: {
            details: 'Detalle de metas',
            employee_name: 'Nombre del empleado',
            active: 'Activo',
            inactive: 'Inactivo',
            inactive_goal: 'META INACTIVA',
            reason: 'Razón',
            search_brand: 'Buscar marcas...',
            search_resale: 'Buscar socios de negocio...',
            search_warehouse: 'Buscar depósitos...',
            search_cost_centers: 'Buscar centros de costo...',
            change_goal: 'Cambiar',
            save: 'Ahorrar',
            jan: 'Ene',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Abr',
            may: 'May',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Ago',
            sep: 'Sep',
            oct: 'Oct',
            nov: 'Nov',
            dec: 'Dic',
            not_applicable: 'No aplicable',
            close_goal: 'Cerrar meta',
            brands_add: 'Marcas para agregar',
            choose_brands: 'Elija marcas para agregar',
            cost_centers: 'Centros de costo',
            cost_center_to_add: 'Centro(s) de costo a ser(es) añadido(s)',
            choose_cost_centers_to_add: 'Elija el/los centro(s) de costo para añadir',
        },
        goals_delete: {
            close_goal: '¿Desea cerrar la meta?',
            reason: 'Ingrese el motivo del cierre',
            goal_closed: 'Meta cerrada con éxito',
            delete_text: '¿Realmente quieres eliminar el objetivo?',
            delete_period: 'Periodo de',
            to: 'hasta',
        },
        invoices: {
            notes: 'Notas',
            filter_notes: 'Filtrar notas por',
            note_filter: 'Filtro de notas',
            select_date: 'Seleccione la fecha de "Desde" y "Hasta"',
            refine_notes: 'Refine su búsqueda por notas a continuación',
            note_number: 'Número de la nota:',
            note: 'Nota...',
            customer_name: 'Nombre del Cliente:',
            customer: 'Cliente...',
            resale_name: 'Nombre del socio de negocio:',
            resale_name_: 'Nombre del socio de negocio',
            resale_notes: 'Socio de Negocio...',
        },
        billing_notes: {
            billing_notes: 'Notas de Facturación',
            receiving_notes: 'Notas de Recepción',
            resale_code: 'Código del Socio',
            resale_name_note: 'Nombre del Socio',
            customer_code: 'Código de Cliente',
            customer_name_code: 'Nombre del Cliente',
            total_resale: 'Total del Socio',
            base_note: 'Base',
            display_commissions: 'Mostrar comisiones',
            category: 'Categoría',
        },
        receipt_notes: {
            installments: 'Cuotas',
            receiptDate: 'Fecha de Recepción',
            totalmargin: 'Margen Total',
            installmentmargin: 'Margen de Cuota',
        },
        reports: {
            reports: 'Informes',
            report_type: 'Seleccione el tipo de informe',
            select_month: 'Selecciona el mes',
            report_title_monthly_available: 'Comisión mensual disponible',
            report_title_provision: 'Comité de Provisiones (Conferencia)',
            report_title_summary: 'Resumen de facturación del mes',
            report_title_individual: 'Comisión Individual',
            report_title_available_goal: 'Comisiones disponibles por objetivo',
            report_title_future: 'Comisiones Futuras',
            report_title_billing: 'Notas de facturación',
            report_title_receipt: 'Notas de recibo',
            report_title_cost_center: 'Totalización por centro de coste',
            report_title_dre: 'DRE por empleado',
            report_description_monthly_available: "Informe que contiene la suma de ingresos y la suma de comisiones disponibles en el mes del empleado",
            report_description_provision: "Informe que contiene ingresos y comisiones disponibles para el mes, separados por objetivo de empleado",
            report_description_summary: "Informe que contiene el \"Resumen de facturación del mes\" como se ve en el perfil del empleado",
            report_description_individual: "Informe que contiene las \"Comisiones Disponibles\" tal como se ven en el perfil del empleado",
            report_description_available_goal: "Informe que contiene las \"Comisiones Disponibles\" del mes separadas por meta de empleado",
            report_description_future: "Informe que contiene \"Comisiones Futuras\" como se ve en el perfil del empleado",
            report_description_billing: "Informe que contiene las facturas facturadas en el periodo solicitado",
            report_description_receipt: "Informe que contiene notas recibidas en el período solicitado.",
            report_description_cost_center: "Informe que contiene la facturación del mes separada por \"Centro de Costos\"",
            report_description_dre: "Informe que contiene la declaración de resultados del mes seleccionado para el empleado seleccionado",
        },
        brands_create: {
            brand_registration: 'Registro de Marca',
            brands_name: 'Nombre correspondiente a la marca',
            sap_identifier: 'Identificador de la marca en SAP',
            brand_logo: 'Logo de la Marca',
            file_name: 'Nombre del archivo...',
            upload_image: 'Subir la imagen',
            register_brand: 'Registrar marca',
            update_brand: 'Actualizar marca',
        },
        brands_table: {
            brand_table: 'Nombre de la marca',
        },
        brands_delete: {
            deactivate_brand: '¿Desea realmente desactivar la marca',
        },
        warehouse_create: {
            warehouses: 'Depósitos',
            warehouse_title: 'Nombre del depósito',
            warehouse_registration: 'Registro de depósito',
            warehouse_name: 'Nombre correspondiente al depósito',
            sap_identifier_warehouse: 'Identificador del depósito en SAP',
            warehouse_base: 'Base del Depósito',
            warehouse_created: '¡Depósito creado con éxito!',
        },
        warehouse_table: {
            search_deposit: 'Buscar en la tabla',
        },
        warehouse_delete: {
            confirm_dactivate_warehouse: '¿Desea realmente desactivar el depósito',
        },
        resale_delete: {
            confirm_dactivate_resale: '¿Realmente desea inactivar al socio de negocios',
        },
        resale_create: {
            title: 'Registro del Socio de Negocios',
            cnpj: 'CNPJ del Socio de Negocios',
            placeholder_code: 'Identificador del Socio',
            value: 'Valor',
            resale_code: 'Código del Socio',
        },
        contributor_summary: {
            value_month: 'Valores referidos a {value}',
            revenue_margin: 'Margen de Ingresos',
            total_revenue: 'Ingreso Total',
            commission_available: 'Comisión Disponible',
            progress_in_the_month: 'Progreso de objetivos para el mes',
            active_goals: 'Objetivos habilitados',
            dont_apply: '- los filtros no se aplican aquí',
            all_goals: 'Ver todas las metas',
            summary_margin: 'Resumen de margen en mes',
            progress: 'Progreso',
            color: 'Color',
            trigger: 'Desencadenar',
            blue_message: 'Objetivo en progreso',
            green_message: 'Meta alcanzada y cuenta desempeño',
            grey_message: 'El objetivo no cuenta el rendimiento',
            available_commissions: 'Comisiones disponibles',
            future_commissions: 'Comisiones futuras',
            annual_billing: 'Facturación Anual',
            annual_goal: 'Meta Anual',
            goal_group: 'Grupo de Metas',
            annual_margin: 'Margen Anual'
        },
        results: {
            customer: 'cliente',
            number_installments: 'Cant. Cuotas',
            invoicing_number: 'Fecha de facturación',
            receipt_date: 'Fecha de recepción',
            total_margin: 'Margen total',
            installment_margin: 'Margen de pago',
            goal: 'Meta',
        },
        future_commisions: {
            line_red: 'Linhas em vermelho indicam notas fiscais com pendência financeira',
            code_costumer: 'Codigo del cliente',
            costumer_name: 'Nombre del cliente',
        },
        settings: {
            settings: 'Ajustes',
            users: 'Usuarios',
            available_users: 'Usuarios disponibles',
            register: 'Registro',
            registration_SAP: 'Registro en SAP',
            code: 'Código',
            permission: 'Permiso',
            master: 'Administrador maestro',
            hiring_model: 'modelo de contratación',
            new_user: 'Crear nuevo',
            select_user: 'Seleccione un usuario disponible en la siguiente tabla para registrarse en la plataforma',
            search_table: 'Búsqueda de tabla',
            user_name: 'Nombre de usuario',
            permissions: 'Permisos',
            action_inactivate: '¿Realmente desea desactivar el usuario',
        },
        role: {
            function_title: 'Funciones',
            registration_function_title: 'Registro de roles',
            name_function: 'Nombre de la función',
            description_function: 'Función descriptiva',
            register_function: 'Función de registro',
            ok: 'De Acuerdo',
            action_inactivate_role: '¿Realmente desea desactivar la función',
        },
        seasoning: {
            register_seasonality_title: 'Registro de estacionalidad',
            seasonity_title: 'Nombre de estacionalidad',
            name_seasonality: ' Nombre correspondiente a la estacionalidad',
            description_seasonality: 'Descripción correspondiente a la estacionalidad',
            start_date: 'Fecha de inicio',
            end_date: 'Fecha final',
            type_seasonality: 'Selecciona el tipo de estacionalidad que registrarás',
            monthly: 'Mensual',
            quarter: 'Quarter',
            value: 'Valor',
            register_seasonality: 'Atención La suma de las ponderaciones de estacionalidad será del 100%.',
            action_inactivate_seasonality: '¿Realmente desea desactivar la estacionalidad',
            value_percent: 'Valor %',
            first_quarter: 'Q1',
            second_quarter: 'Q2',
            third_quarter: 'Q3',
            fourth_quarter: 'Q4',
            select_type: 'Selecciona el tipo de estacionalidad',
        },
        triggers: {
            trigger_title: 'Registro de activación',
            trigger_name_table: 'Nombre del disparador',
            trigger_name: 'Nombre correspondiente al disparador',
            interval_value: ' Valor de rango',
            final_value: ' Valor final',
            add_range: ' Agregar rango',
            delete_last_range: 'Eliminar el último rango',
            interval: 'Intervalo',
            warning_trigger: 'La suma de los elementos desencadenantes debe ser del 100%.',
            bonus: 'Bonificación',
            bonus_above_one_hundred: 'Ingrese el porcentaje de bonificación',
            action_inactivate_triggers: '¿Realmente desea desactivar el activador',
            triger_item_value_not_defined: 'Valor de activación no definido',
            order_modal: 'Orden',
            initial_value_modal: 'Valor Inicial del Intervalo',
            final_value_modal: 'Valor Final del Intervalo',
        },
        messages: {
            goal_required_field_missing: 'Campo obligatorio en portería no lleno',
            trigger_item_not_found: 'Elemento desencadenante no encontrado',
            triger_item_value_not_defined: 'El valor del artículo de gatilho no está definido',
            clearance_sale_reward_not_defined: 'Recompensa de Saldão no definida',
            triger_item_not_defined: 'Artículo de gatilho no definido',
            reason_required: 'Es obligatorio rellenar el campo motivo.',
            brands_required: 'El campo de marca es obligatorio',
            goal_already_exists: 'El gol ya está registrado',
            brand_already_registered: 'La marca ya está registrada.',
            result_not_found: 'Resultado inesperado',
        },
        validations: {
            invalid_credentials: 'Credenciales no válidas',
            brand_create_success: 'Marca creada con éxito',
            brand_create_fail: 'Error al crear la marca',
            brand_update_success: 'Marca actualizada con éxito',
            brand_update_fail: 'Error al actualizar la marca',
            brand_delete_success: 'Marca eliminada correctamente',
            brand_delete_fail: 'Error al eliminar la marca',
            missing_required_fields: 'Campos obligatorios no cumplimentados',
            configuration_not_found: 'Configuración no encontrada',
            configuration_create_success: 'Configuración creada exitosamente',
            configuration_create_fail: 'Error al registrar la configuración',
            configuration_update_success: 'Configuración actualizada exitosamente',
            configuration_update_fail: 'Error al actualizar la configuración',
            start_date_greater_than_end_date: 'Fecha de inicio mayor que la fecha de finalización',
            error_consulting_database: 'Error al consultar la base de datos',
            goal_required_field_missing: 'Campos obligatorios no completados en la meta ',
            trigger_item_not_found: 'Elemento activador no encontrado',
            triger_item_value_not_defined: 'Valor del elemento activador no definido',
            clearance_sale_reward_not_defined: 'Valor de recompensa de Saldão no definido',
            reason_required: 'La razón es obligatoria',
            users_ids_null: 'El usuario no debe ser nulo o indefinido',
            roles_ids_null: 'La función no debe ser nula o indefinida',
            seasons_ids_null: 'La estacionalidad no debe ser nula o indefinida.',
            performants_null: 'La ejecutante no debe ser nula ni indefinida.',
            goal_liness_null: 'Las líneas de gol no deben ser nulas ni indefinidas.',
            goal_user_not_found: 'Colaborador no encontrado',
            goal_role_not_found: 'Función no encontrada',
            goal_seller_not_found: 'Vendedor no encontrado',
            goal_already_exists: 'El objetivo ya existe',
            invoice_not_found: 'Factura no encontrada',
            item_not_found: 'Objeto no encontrado',
            performant_not_found: 'Performante no encontrado',
            preview_not_found: 'Vista previa no encontrada',
            provision_not_found: 'Disposición no encontrada',
            reception_not_found: 'Recibo no encontrado',
            resale_create_success: 'Socio comercial creado exitosamente',
            resale_create_fail: 'Error al crear socio comercial ',
            resale_update_success: 'Socio comercial actualizado exitosamente',
            resale_update_fail: 'Error al actualizar el socio comercial',
            resale_delete_fail: 'Error al eliminar socio comercial',
            resale_delete_success: 'El socio comercial se eliminó correctamente',
            role_not_found: 'Función no encontrada',
            role_create_success: 'Función creada con éxito',
            role_create_fail: 'Error al crear la función',
            role_update_success: 'Función actualizada con éxito',
            role_update_fail: 'Función de actualización de errores',
            role_delete_fail: 'Función de eliminación de errores',
            role_delete_success: 'Función eliminada exitosamente',
            season_not_found: 'Estacionalidad no encontrada',
            season_hundred_error: 'La suma de las ponderaciones de estacionalidad debe ser del 100%.',
            season_create_success: 'Estacionalidad creada con éxito',
            season_create_fail: 'Error al crear estacionalidad',
            season_delete_fail: 'Error al eliminar la estacionalidad',
            season_delete_success: 'La estacionalidad se eliminó correctamente',
            trigger_not_found: 'Activador no encontrado',
            trigger_items_not_set: 'Rangos de activación no completados',
            trigger_item_value_error: 'Error al pasar el valor de los elementos desencadenantes',
            trigger_item_hundred_error: 'La suma de los elementos desencadenantes debe ser del 100 %.',
            trigger_item_create_fail: 'Error al crear elementos desencadenantes',
            trigger_create_success: 'Activador creado exitosamente',
            trigger_create_fail: 'Error al crear el disparador',
            trigger_item_delete_fail: 'Error al eliminar el elemento desencadenante',
            trigger_delete_fail: 'Error al eliminar el activador',
            trigger_delete_success: 'Desencadenador eliminado exitosamente',
            user_not_found: 'Usuario no encontrado',
            user_create_success: 'Usuario creado exitosamente',
            user_create_fail: 'Error al crear usuario',
            user_update_success: 'Usuario actualizado exitosamente',
            user_update_fail: 'Error al actualizar usuario',
            user_delete_success: 'Usuario eliminado exitosamente',
            user_delete_fail: 'Error al eliminar usuario',
            preference_not_set: 'Preferencia no establecida',
            user_preference_success: 'Desarmar preferencia de usuario',
            user_preference_fail: 'Error al crear usuario de preferencia',
            warehouse_create_success: 'Depósito creado exitosamente',
            warehouse_create_fail: 'Error al crear el depósito',
            warehouse_update_success: 'Depósito actualizado exitosamente',
            warehouse_update_fail: 'Error al actualizar el depósito',
            warehouse_delete_success: 'Depósito eliminado exitosamente',
            warehouse_delete_fail: 'Error al eliminar el depósito',
            unauthorized: 'No autorizado',
            InternalServer_Error: 'Ops...Se produjo un error inesperado en el sistema, comuníquese con el soporte técnico.',
            only_image_allowed: 'Sólo se permiten archivos de tipo imagen',
            resale_already_exists: 'El socio comercial ya existe',
            sap_users_id: 'El campo "Registro SAP" no puede estar vacío',
            sap_card_code: 'El campo "Código de socio comercial" no puede estar vacío',
            sap_card_name: 'El campo "Nombre" no puede estar vacío',
            sap_code: 'El campo "Código SAP" no puede estar vacío',
            company: 'El campo "Base del depósito" no puede estar vacío',
            start_date: 'El campo "Fecha de inicio" no puede estar vacío',
            end_date: 'El campo "Fecha de finalización" no puede estar vacío',
            jan: 'El campo "Enero" no puede estar vacío',
            feb: 'El campo "febrero" no puede estar vacío',
            mar: 'El campo "Marzo" no puede estar vacío',
            apr: 'El campo "Abril" no puede estar vacío',
            may: 'El campo "Mayo" no puede estar vacío',
            jun: 'El campo "Junio" no puede estar vacío',
            jul: 'El campo "julio" no puede estar vacío',
            aug: 'El campo "Agosto" no puede estar vacío',
            sep: 'El campo "Septiembre" no puede estar vacío',
            oct: 'El campo "Octubre" no puede estar vacío',
            nov: 'El campo "Noviembre" no puede estar vacío',
            dec: 'El campo "Diciembre" no puede estar vacío',
            brands_required: 'Ingrese la marca a agregar',
            brand_already_registered: 'Marca ya registrada en la meta',
            items_required: 'Artículo no informado',
            invoice_or_item_not_found: 'Artículo o Factura no encontrado',
            item_update_fail: 'Error al actualizar el artículo',
            item_update_success: 'Artículo actualizado con éxito',
        },
        breadcrumbs: {
            invoices: 'Notas',
            goals: 'Objetivos',
            reports: 'Informes',
            settings: 'Configuración',
        },
        edit_invoice: {
            warning_message: 'Ningún margen ha sido modificado',
            verify_message: '¿Está seguro de que desea guardar los cambios en el margen de las facturas?',
            success_message: 'Facturas actualizadas con éxito',
            customer_code: 'Código de cliente',
            customer_name: 'Nombre de cliente',
            item_total: 'Total del artículo',
            btn_title: 'Cambiar el margen de la factura',
            title_edit: 'Cambiar el valor del margen del artículo',
        },
        status: {
            invoiced: "Facturado",
            cancelled: "Cancelado",
            returned: "Devuelto",
            return_cancelled: "Devolución Cancelada"
        },
        goals_group: {
            goal_group_created_successfully: '¡Grupo de metas creado con éxito!',
            create_group: 'Crear grupo',
            create_new_group: 'Crear nuevo grupo',
            select_group: 'Seleccionar grupo',
            view_group_details: 'Ver detalles del grupo',
        }
    },
};